import { colors } from 'config/themes/colors';
import styled, { DefaultTheme } from 'styled-components';
import { CalloutVariant } from './Callout.types';

const variantColors = (variant: CalloutVariant, theme: DefaultTheme) => {
  const isDark = theme.name === 'atsDark';
  switch (variant) {
    case 'success':
      return {
        background: isDark ? `${colors.green[500]}1f` : colors.green[50],
        border: isDark ? `${colors.green[500]}66` : colors.green[100],
        accent: colors.green[500],
        text: isDark ? colors.green[100] : colors.green[900],
      };
    case 'warning':
      return {
        background: isDark ? `${colors.yellow[500]}1f` : colors.yellow[50],
        border: isDark ? `${colors.yellow[500]}66` : colors.yellow[200],
        accent: colors.yellow[500],
        text: isDark ? colors.yellow[100] : colors.yellow[900],
      };
    case 'error':
      return {
        background: isDark ? `${colors.red[500]}1f` : colors.red[50],
        border: isDark ? `${colors.red[500]}66` : colors.red[100],
        accent: colors.red[500],
        text: isDark ? colors.red[100] : colors.red[900],
      };
    default:
      return {
        background: isDark ? `${colors.blue[400]}1f` : colors.blue[50],
        border: isDark ? `${colors.blue[400]}66` : colors.blue[150],
        accent: colors.blue[500],
        text: isDark ? colors.blue[100] : colors.blue[900],
      };
  }
};

export const CalloutStyled = styled.div<{ $variant: CalloutVariant }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${({ $variant, theme }) => variantColors($variant, theme).border};
  border-left: 4px solid ${({ $variant, theme }) => variantColors($variant, theme).accent};
  background: ${({ $variant, theme }) => variantColors($variant, theme).background};
  color: ${({ $variant, theme }) => variantColors($variant, theme).text};
  font-size: 0.85rem;
  line-height: 1.4;

  > svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    color: ${({ $variant, theme }) => variantColors($variant, theme).accent};
  }

  .callout-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .callout-title {
    font-weight: 700;
    color: inherit;
  }

  .callout-text {
    font-weight: 400;
    color: inherit;
  }
`;
